import { render, staticRenderFns } from "./TagLink.vue?vue&type=template&id=29f57be8&scoped=true&"
import script from "./TagLink.vue?vue&type=script&lang=js&"
export * from "./TagLink.vue?vue&type=script&lang=js&"
import style0 from "./TagLink.vue?vue&type=style&index=0&id=29f57be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f57be8",
  null
  
)

export default component.exports